// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// @mui material components
import Badge from "@mui/material/Badge";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import DefaultUserAvatar from "layouts/pages/account/components/Header/components/DefaultUserAvatar";
import { ThemedMailIcon } from "assets/CXFIcons/Static";

function ProductCellfromUser({ id, image, name, email, firstName, lastName, status, userStatus }) {
   const userStatusBadgeColor = () => {
      if (status === "active") {
         return "success";
      } else {
         return "dark";
      }
   };

   return (
      <SoftBox display="flex" alignItems="center" width="100%">
         <SoftBox mx={1} marginRight="12px" my={1} minWidth="3.75rem">
            <Badge
               variant="dot"
               color={userStatusBadgeColor()}
               anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right"
               }}
               size="large"
               sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  height: "3.75rem",
                  "& .MuiBadge-dot": {
                     width: 13,
                     height: 13,
                     borderRadius: "50%",
                     zIndex: "initial",
                     bottom: 4,
                     right: 4
                  }
               }}
            >
               {image && image.trim() ? (
                  <SoftBox component="img" src={`${image}`} alt={name} width="100%" height="3.75rem" borderRadius="md" border="0.5px solid #E6E6E6" sx={{ objectFit: "cover", maxWidth: "60px" }} />
               ) : (
                  <DefaultUserAvatar
                     firstName={firstName}
                     lastName={lastName}
                     variant={"rounded"}
                     size="xxxl"
                     border="unset"
                     disableFocusListener={false}
                     disableTouchListener={false}
                     open={false}
                     sx={{ border: "0.5px solid #E6E6E6 !important" }}
                  />
               )}
            </Badge>
         </SoftBox>
         {userStatus === "invited" ? (
            <SoftBox sx={{ display: "inline" }}>
               <SoftTypography sx={{ color: "#2D3748" }} className="white-to-dark" variant="button" fontWeight="bold">
                  {name}
               </SoftTypography>
               <br />
               <SoftTypography variant="button" color="secondary" sx={{ fontWeight: 400, display: "flex", alignItems: "center" }}>
                  <ThemedMailIcon width="19px" height="19px" />
                  {email}
               </SoftTypography>
            </SoftBox>
         ) : (
            <Link to={`/account/users/profile-overview/${id}`} style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>
               <SoftBox sx={{ display: "inline" }}>
                  <SoftTypography sx={{ color: "#2D3748" }} className="white-to-dark" variant="button" fontWeight="bold">
                     {name}
                  </SoftTypography>
                  <br />
                  <SoftTypography variant="button" color="secondary" sx={{ fontWeight: 400, display: "flex", alignItems: "center" }}>
                     <ThemedMailIcon width="19px" height="19px" />
                     {email}
                  </SoftTypography>
               </SoftBox>
            </Link>
         )}
      </SoftBox>
   );
}

// Typechecking props for the ProductCellfromUser
ProductCellfromUser.propTypes = {
   image: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired
};

export default ProductCellfromUser;
